export default __webpack_public_path__ + "static/media/assigned.088bfc78.svg";